export default __webpack_public_path__ + "static/media/dexynth-logo-green.08788805.png";